import {Component, effect, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {
  IonButton,
  IonCol, IonInput, IonItem,
  IonRow,
  IonSearchbar, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonSpinner, IonToolbar, PopoverController
} from "@ionic/angular/standalone";
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PropertyService} from '../../property.service';
import { DecimalPipe} from '@angular/common';
import {FilterService} from '../../../common/filter/filter.service';
import {Router} from '@angular/router';
import {FilterPopoverComponent} from '../filter-popover/filter-popover.component';
import {CurrencyConvertService} from '../../../core/currency.convert.service';
import {components} from '../../../configs/config';
import {LanguageService} from '../../../core/language.service';

@Component({
    selector: 'app-listing-filter',
    templateUrl: './listing-filter.component.html',
    styleUrls: ['./listing-filter.component.scss'],
  imports: [
    IonButton,
    IonRow,
    IonSearchbar,
    FormsModule,
    IonCol,
    ReactiveFormsModule,
    DecimalPipe,
    IonSpinner,
    IonSelect,
    IonSelectOption,
    IonSegment,
    IonSegmentButton,
    IonToolbar,
    IonItem,
    IonInput
  ]
})
export class ListingFilterComponent  implements OnInit {
  @Output() filterChanged = new EventEmitter<any>();
  @Input() urlParams: any;
  searchQuery = new FormControl('');
  priceRange = new FormControl({ lower: 0, upper: 1000 })
  floorRange = new FormControl({ lower: 0, upper: 10 })
  ageRange = new FormControl({ lower: 0, upper: 10 });
  bedrooms = new FormControl(0);
  propertyService: PropertyService = inject(PropertyService);
  popoverController: PopoverController = inject(PopoverController);
  isPopOverClosed = false;
  currencyConvertService: CurrencyConvertService = inject(CurrencyConvertService);
  languageService: LanguageService = inject(LanguageService);
  content: any;
  constructor() {
    effect(async () => {
      if (this.filterService.filterData()) {
        if (Object.keys(this.filterService.filterData()).length) {
        this.updateFields(this.filterService.filterData());
          // await this.searchData(this.filterService.filterData());
        }
        if (Object.keys(this.filterService.filterData()).length) {
          if (this.isPopOverClosed) {
            // await this.searchData(this.filterService.filterData());
          }
        }
      }
    })
  }

  async ngOnInit() {
    await this.propertyService.initializeData();
    if (this.languageService.lang()) {
      this.content = await this.languageService.loadContent(components.filters);
    }

    if (this.urlParams && Object.keys(this.urlParams).length && (this.urlParams.sub || this.urlParams.city) && (!this.urlParams.minPrice)) {
      this.filterService.filterData.set({...this.urlParams, ...(this.propertyService.filterValues() || {})});
    } else {
      this.updateFields(this.propertyService.filterValues() || {});
    }
    this.searchQuery.valueChanges.subscribe(async (value: any) => {
      if (value.length > 2) {
        this.filterChanged.emit(value);
      } else {
        this.filterChanged.emit(null);
      }
    })
  }
updateFields(filterValues: any) {
  let currentFilterValues = filterValues || {};

  if (!Object.keys(currentFilterValues).length) {
    currentFilterValues = this.propertyService.filterValues() || {};
  }

  this.priceRange.patchValue({
    lower: currentFilterValues.minPrice ?? 0,
    upper: currentFilterValues.maxPrice ?? 1000,
  })
  this.floorRange.patchValue({
    lower: currentFilterValues.minFloorArea ?? 0,
    upper: currentFilterValues.maxFloorArea ?? 10,
  })
  this.ageRange.patchValue({
    lower: currentFilterValues.minAge ?? 0,
    upper: currentFilterValues.maxAge ?? 10,
  });
}

  filterService: FilterService = inject(FilterService);
  router: Router = inject(Router);
  async searchData(values: any) {
    await this.router.navigate(['/listings', 'filter'], {queryParams: {...values} });

  }

/*
  filterProperties() {
    const  values: any = {}; // this.filterForm.value;
    if (this.isFilterChanged) {
      values.minPrice = this.priceRange.value?.lower;
      values.maxPrice = this.priceRange.value?.upper;
      values.maxFloorArea = this.floorRange.value?.upper;
      values.minFloorArea = this.floorRange.value?.lower;
      values.maxAge = this.ageRange.value?.upper;
      values.minAge = this.ageRange.value?.lower;
    }
    if (this.propertyService.selectedCategory()) {
      values.subCatId = this.propertyService.selectedCategory()._id;
    }
    if (this.filterForm.value.beds === 0) {
      delete this.filterForm.value.beds;
    }
    if (this.filterForm.value.baths === 0) {
      delete this.filterForm.value.baths;
    }
    this.filterService.filterData.set({...values, ...this.filterForm.value})

    this.router.navigate(['/listings', 'filter'], {queryParams: {...values, ...this.filterForm.value} });
  }

 */
  async showFilterPopover(type: string, $event: any) {
    const popover = await this.popoverController.create({
      component: FilterPopoverComponent,
      event: $event,
      focusTrap: $event,
      cssClass: 'filter-popover',
      componentProps: {type}
    });
    popover.onDidDismiss()
      .then(() => {
        console.log('popover dismissed');
        this.isPopOverClosed = true;
        this.searchData(this.filterService.filterData());
      })
    await popover.present();
  }

  resetFilter() {
    this.filterService.filterData.set(null);
    this.updateFields(this.propertyService.filterValues());
    this.router.navigate(['/listings', 'rent']);
  }
  furnishingType: any;
  dropDownClosed($event: any) {
    const furnishingType = this.furnishingType.toString();
    this.filterService.filterData.update(value => ({...value, furnishingType}));
    this.searchData(this.filterService.filterData());
  }
}
